import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.EditingMatrixPopupContent', {
    editingMatrixForTheStep: 'Editing matrix for the step "{step}"',
    save: 'Save',
    invalidConditions: 'Please ensure that all set conditions are valid',
    alertMessage:
        'These rules will define which value an approver can edit. You can not add new value, only select from the list approval matrix for the step.',
});
